var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.77735 7.48177C0.445072 7.70329 -2.33817e-08 7.46509 -4.08377e-08 7.06574L-3.08853e-07 0.934258C-3.26309e-07 0.534911 0.445072 0.296715 0.77735 0.518233L5.37596 3.58397C5.67283 3.78189 5.67283 4.21811 5.37596 4.41602L0.77735 7.48177Z",
    fill: "#8F90A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeRight);
export default __webpack_public_path__ + "static/media/Shape_right.6dac913d8d9ba8b06842bbbf52a01b38.svg";
export { ForwardRef as ReactComponent };